import { motion } from "framer-motion";
import { features } from "@/mocks/models";

export default function FeaturesSection() {
  return (
    <section className="px-4 py-5">
      <div className="grid grid-cols-3 gap-3">
        {features.map((feat, index) => (
          <motion.a
            key={index}
            href="#download"
            className="flex flex-col items-center rounded-xl bg-background-100/80 p-4 text-center backdrop-blur-sm cursor-pointer"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{
              duration: 0.4,
              delay: index * 0.1,
              ease: [0.25, 0.4, 0.25, 1],
            }}
            whileHover={{ y: -4, scale: 1.03 }}
            whileTap={{ scale: 0.96 }}
          >
            <motion.div
              className="mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/20 text-lg text-primary-400 md:h-12 md:w-12"
              whileHover={{ rotate: [0, -8, 8, -4, 0] }}
              transition={{ duration: 0.4 }}
            >
              <i className={feat.icon} />
            </motion.div>
            <div className="text-xs font-bold text-foreground-100 md:text-sm">
              {feat.title}
            </div>
            <div className="mt-0.5 text-[10px] text-foreground-600 md:text-xs">
              {feat.subtitle}
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}